import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withFirebase } from "../../../firebaseComponents/context";
// util
import compose from "../../../utils/compose";
// styles
import styles from "./Login.module.css";

function extractEventData(cb) {
  return (e) => {
    e.preventDefault();
    cb(e.target.value);
  };
}

function LoginForm({ firebase, history }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    firebase
      .signInWithEmailAndPassword(email, password)
      .then(({ user }) => history.push("/admin/warr"))
      .catch((e) => {
        if (e.code === "auth/user-not-found")
          return setError("Credentials not found, please try again.");
        setError(
          "An unknown error occurred, please contact site administrator."
        );
      });
  }

  return (
    <form className={styles.loginForm} onSubmit={handleSubmit}>
      <div className={styles.loginError}> {error} </div>
      <label htmlFor="email"> {"Email:"} </label>
      <input
        id="email"
        type="email"
        placeholder="Please enter your email."
        value={email}
        onChange={extractEventData(setEmail)}
      />
      <label htmlFor="password"> {"Password:"} </label>
      <input
        id="password"
        type="password"
        placeholder="Please enter your password."
        value={password}
        onChange={extractEventData(setPassword)}
      />
      <button type="submit"> {"Login"} </button>
    </form>
  );
}

export default compose(withFirebase, withRouter)(LoginForm);
